/* eslint-disable react/forbid-component-props */
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';
import ReactCookies from 'react-cookies';
import { displayGiftingOptionCheckout } from '../../brands/default/config';
import { COOKIES } from '../../brands/default/constants';
import { BASKET_DEAL_PRODUCT_GIFTING } from '../../brands/default/content/components/checkout';
import { GIFT_PACK } from '../../brands/default/features';
import ThemeContext from '../../providers/ThemeProvider';
import CustomNativeSelect from '../_generic/custom-native-select/CustomNativeSelect';
import GiftingInfoModal from './GiftingInfoModal';

export default function BasketDealProductGiftingFull({
  disabled,
  product,
  giftingOptions,
  isBookingCalendarOnRedemptionGift = false,
  onUpdate,
  giftPackPrice,
}) {
  const theme = useContext(ThemeContext);
  const [showModal, setShowModal] = useState(false);
  const [allOptions, setAllOptions] = useState(giftingOptions);
  const showGiftPackPrice = ReactCookies.load(COOKIES.giftPackPrice) === 'b';
  const onModal = (event) => {
    if (event.key && event.key === 'Enter') {
      setShowModal(true);
    }
  };
  const isGiftWrap = giftingOptions.includes('wrapped');

  useEffect(() => {
    if (!GIFT_PACK) {
      const options = giftingOptions.filter(
        (item) => item === 'e-gift' || item === 'none',
      );
      setAllOptions(options);
    }
  }, []);

  return (
    <>
      <div className="gifting gifting--full">
        <label className="gifting__label" id="id-gifting-modal">
          <span className="gifting__label-text">
            {BASKET_DEAL_PRODUCT_GIFTING.giftingOptions}:
          </span>
          <CustomNativeSelect
            ariaLabel={BASKET_DEAL_PRODUCT_GIFTING.giftingOptions}
            className="gifting__select"
            disabled={disabled}
            onChange={(event) => onUpdate(event.target.value)}
            value={product.gifting.type}
          >
            {allOptions.map((option) => {
              // can't switch to non gift here
              if (
                isBookingCalendarOnRedemptionGift &&
                product.gift &&
                option === 'none'
              )
                return null;

              return (
                <option key={option} value={option}>
                  {
                    displayGiftingOptionCheckout(
                      showGiftPackPrice ? giftPackPrice[option] : null,
                    )[option]
                  }
                </option>
              );
            })}
          </CustomNativeSelect>
          <FontAwesomeIcon
            aria-label={BASKET_DEAL_PRODUCT_GIFTING.showGiftingInfo}
            className="gifting__info"
            icon={faInfoCircle}
            onClick={() => setShowModal(true)}
            onKeyDown={onModal}
            role="button"
            tabIndex={0}
          />
        </label>
      </div>

      {
        <GiftingInfoModal
          isGiftWrap={isGiftWrap}
          onClose={() => setShowModal(false)}
          show={showModal}
        />
      }

      <style jsx>{`
        .gifting__label {
          display: flex;
          align-items: center;
          margin-bottom: 0;
        }
        .gifting__label-text {
          color: ${theme.colors.primary};
          font-weight: bold;
          margin-right: 8px;
        }
        :global(.gifting__info) {
          height: 24px !important;
          width: 24px !important;
          color: #cccccc;
          margin-left: 8px;
        }
        :global(.gifting__modal .modal-body) {
          padding-top: 0;
        }
      `}</style>
    </>
  );
}

BasketDealProductGiftingFull.propTypes = {
  disabled: PropTypes.bool,
  giftingOptions: PropTypes.array,
  giftPackPrice: PropTypes.object,
  isBookingCalendarOnRedemptionGift: PropTypes.bool,
  onUpdate: PropTypes.func,
  product: PropTypes.object,
};
